module.exports = __webpack_public_path__ + "img/banner_img.6be8a1c5.png";